import React from 'react'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const AsterSelect = props => {
	return (
		<AsterTextField
			{...props}
			select
			SelectProps={{ IconComponent: ExpandMoreIcon }}
		/>
	)
}
export default AsterSelect
